export default "__VITE_ASSET__7a044d36__"